import { CommonModule } from "@angular/common";
import {
  Component,
  EventEmitter,
  Output,
  QueryList,
  ViewChildren,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Store } from "@ngrx/store";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { Select, SelectModule } from "primeng/select";
import { AutoCompleteComponent } from "src/app/shared/components/ui/auto-complete.component";
import { ClearMultiComponent } from "src/app/shared/components/ui/clear-multi.component";
import { FormEnhanceDirective } from "src/app/shared/components/ui/form-enhance.directive";
import { InputWrapComponent } from "src/app/shared/components/ui/input-wrap.component";
import { Clinic } from "src/app/shared/models/clinic.model";
import { DataElement, Doctor } from "src/app/shared/models/common";
import { keyCodes } from "src/app/shared/models/key-codes.model";
import { DrProfileSearchParams } from "src/app/shared/models/order.model";
import { clinicList, doctorList } from "src/app/shared/ngrx/ngrx-selectors";
import { AppState } from "src/app/shared/redux/store";

@Component({
  selector: "dr-profile-filters",
  templateUrl: "./dr-profile-filters.component.html",
  styleUrls: ["./dr-profile-filters.component.scss"],
  imports: [
    CommonModule,
    FormsModule,
    InputWrapComponent,
    TranslateModule,
    SelectModule,
    FormEnhanceDirective,
    ClearMultiComponent,
  ],
  standalone: true,
})
export class DrProfileFiltersComponent {
  @Output() onSearch = new EventEmitter<DrProfileSearchParams>();
  @Output() onCreate = new EventEmitter();
  @ViewChildren(Select) hasSearchDropDowns: QueryList<Select>;
  @ViewChildren(AutoCompleteComponent)
  hasAutoCompleteControls: QueryList<AutoCompleteComponent>;

  searchParams: DrProfileSearchParams;
  profileId: number;
  selectedDoctor: DataElement;
  selectedClinic: DataElement;
  formBind = this;

  get clinicList(): Clinic[] {
    return this.store.selectSignal(clinicList)();
  }

  get doctorList(): Doctor[] {
    return this.store.selectSignal(doctorList)();
  }
  constructor(private readonly store: Store) { }

  ngOnInit(): void { }

  ngOnDestroy(): void { }

  clearSearch() {
    this.profileId = null;
    this.selectedClinic = null;
    this.selectedDoctor = null;
  }

  search() {
    this.searchParams = {
      profileId: this.profileId,
      doctorId: this.selectedDoctor?.id,
      clinicId: this.selectedClinic?.id,
      searchId: null,
    };

    this.onSearch.emit(this.searchParams);
  }

  onCreateClicked() {
    this.onCreate.emit();
  }

  onKeyPress(e: any) {
    if (e.keyCode == keyCodes.enter) {
      this.search();
    }
  }

  onFieldValueChanged(e: any) {
    this.search();
  }
}
